import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable()

export class AuthService {
	BASE_URL: string = environment.apiUrl;
	USER_URI: string = this.BASE_URL + '/user';

	constructor(private httpClient: HttpClient, private router: Router) { }

	public register = (body) => {
		return this.httpClient.post(this.USER_URI, body);
	}

	public login = (body) => {
		return this.httpClient.post(this.USER_URI + '/login', body);
	}

	public logout() {
		localStorage.clear();
		this.router.navigate(['/auth/login']);
	}

	public isAuthenticated() {
		if (localStorage.getItem('token') !== null) {
			return this.httpClient.get(this.BASE_URL + '/me')
				.map((response: any) => {
					return response.success;
				})
				.catch((error: HttpErrorResponse) => {
					if (error.status === 401) {
						this.logout(); // Aquí se llama a la función logout
					}
					// Otro manejo de errores...
					return Observable.throw(error);
				});
		} else {
			this.logout(); // Si no hay token, llama a la función logout
			return Observable.of(false);
		}
	}

	// public isAuthenticated() {
	// 	if (localStorage.getItem('token') !== null) {
	// 		return this.httpClient.get(this.BASE_URL + '/me')
	// 			.map((response:any) => {
	// 				return response.success;
	// 			});
	// 	} else {
	// 		return false;
	// 	}
	// }

	public setToken(token) {
		localStorage.setItem('token', token);
	}

	public getToken() {
		return localStorage.getItem('token');
	}

	public recoverPassword(body) {
		return this.httpClient.post(this.USER_URI + '/forgot-password', body);
	}

	public resetPassword(token, body) {
		return this.httpClient.post(this.USER_URI + `/reset-password/${token}`, body);
	}

}


// WEBPACK FOOTER //
// ./src/app/services/auth.service.ts